import urls from 'urls';

export const useEmailPreview = ({eventId}) => {
  const sendEmailPreview = async () => {
    const errorDefault =
      'Unknown error while attempting to send your email preview. Please check the email address and try again.';

    window.dataLayer.push({
      event: 'checkOutLinks',
      checkOutLinkClicked: 'email preview',
    });

    try {
      const url = urls.get('ajax_email_preview', {
        // biome-ignore lint/style/useNamingConvention: camel case>
        event_id: eventId,
      });

      const response = await evite.fetch(url, {
        method: 'post',
        credentials: 'include',
        cache: 'no-cache',
        headers: {
          'X-CSRFToken': evite.cookie('csrftoken'),
          Accept: 'application/json',
        },
      });
      const data = await response.json();

      if (response.ok) {
        // biome-ignore lint/suspicious/noAlert: allow alert
        alert(
          'Success! Your email preview has been sent to the primary email address on this account.'
        );
      } else {
        evite.error(data.message || errorDefault);
      }
    } catch (e) {
      evite.error('Failed to update', e);
    }
  };

  return {sendEmailPreview};
};
